/**
 * YouTube video category labels. A category set in the CMS wins, then the
 * video type (stream / short) from the sync, then title keywords.
 */
export const VIDEO_CATEGORIES = ['Tutorials', 'Gameplay', 'Live Streams', 'Shorts'];

export const VIDEO_TYPE_LABELS = {
  video: 'Video',
  stream: 'Live Stream',
  short: 'Short',
};

export function getVideoCategory(video) {
  if (video.category) {
    return video.category;
  }
  if (video.type === 'stream') {
    return 'Live Streams';
  }
  if (video.type === 'short') {
    return 'Shorts';
  }
  const title = video.snippet.title;
  if (
    title.includes('| Part ') ||
    /gameplay|playthrough|let's play|\| PC \||platinum/i.test(title)
  ) {
    return 'Gameplay';
  }
  return 'Tutorials';
}

export function sortVideosByDate(videos) {
  return [...videos].sort(
    (a, b) =>
      new Date(b.snippet.publishedAt).getTime() -
      new Date(a.snippet.publishedAt).getTime(),
  );
}
